import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { CreateAppropriatorRequest } from '../admin-appropriators.component';

@Component({
  selector: 'app-add-appropriator-modal',
  templateUrl: './add-appropriator-modal.component.html',
  styleUrls: ['./add-appropriator-modal.component.scss']
})
export class AddAppropriatorModalComponent {

  constructor(
    private activeModal: NgbActiveModal
  ) { }

  newAppropriatorSubmit(appForm: NgForm) {
    this.activeModal.close({
      name: appForm.value.newAppName,
      email: appForm.value.newAppEmail,
      address: appForm.value.newAppAddress,
      phoneNumber: appForm.value.newAppPhoneNumber,
    } as CreateAppropriatorRequest);
  }

}
